var _rect, _path, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnlineDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    rx: 8,
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.255 11.9975L19.755 11.2475C19.4775 11.1125 19.1325 11.2175 18.9975 11.495C18.855 11.78 18.9675 12.1175 19.245 12.2525L20.4375 12.845V16.4375L17.625 16.445V8.75C17.625 7.25 16.62 6.5 15.375 6.5H9.375C8.13 6.5 7.125 7.25 7.125 8.75V20.9375H6C5.6925 20.9375 5.4375 21.1925 5.4375 21.5C5.4375 21.8075 5.6925 22.0625 6 22.0625H18.75C19.0575 22.0625 19.3125 21.8075 19.3125 21.5C19.3125 21.1925 19.0575 20.9375 18.75 20.9375H17.625V17.57L21 17.5625C21.315 17.5625 21.5625 17.3075 21.5625 17V12.5C21.5625 12.29 21.4425 12.095 21.255 11.9975ZM9 10.1675C9 9.125 9.6375 8.75 10.4175 8.75H14.34C15.1125 8.75 15.75 9.125 15.75 10.1675V11.09C15.75 12.125 15.1125 12.5 14.3325 12.5H10.4175C9.6375 12.5 9 12.125 9 11.0825V10.1675ZM9.375 14.1875H11.625C11.9325 14.1875 12.1875 14.4425 12.1875 14.75C12.1875 15.0575 11.9325 15.3125 11.625 15.3125H9.375C9.0675 15.3125 8.8125 15.0575 8.8125 14.75C8.8125 14.4425 9.0675 14.1875 9.375 14.1875Z",
    fill: "#2E9E3A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 14.772,
    width: 6.66667,
    height: 7,
    rx: 3.33333,
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 14.772,
    width: 6.66667,
    height: 7,
    rx: 3.33333,
    stroke: "#E9ECEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8333 15.272C15.2679 15.272 14 16.6145 14 18.272C14 18.8345 14.1487 19.367 14.4108 19.817C14.8996 20.687 15.7992 21.272 16.8333 21.272C17.8675 21.272 18.7671 20.687 19.2558 19.817C19.5179 19.367 19.6667 18.8345 19.6667 18.272C19.6667 16.6145 18.3987 15.272 16.8333 15.272ZM18.2996 17.9495L16.7908 19.427C16.6917 19.5245 16.5571 19.577 16.4296 19.577C16.295 19.577 16.1604 19.5245 16.0542 19.412L15.3529 18.6695C15.1475 18.452 15.1475 18.092 15.3529 17.8745C15.5583 17.657 15.8983 17.657 16.1037 17.8745L16.4438 18.2345L17.5771 17.1245C17.7896 16.9145 18.1296 16.9295 18.3279 17.1545C18.5263 17.3795 18.5121 17.732 18.2996 17.9495Z",
    fill: "#2E9E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnlineDevice);
export default __webpack_public_path__ + "static/media/online-device.1e441130a30af58c541bb06f58afab40.svg";
export { ForwardRef as ReactComponent };